import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Input from '@components/shared/form/Input'
import { ClientService } from '@services/index'
import { isValidEmail } from '@utils/validators/string.validator'

interface Props {
  outdatedPassword: boolean
  goBack: () => void
}
const ForgotPassword: React.FC<Props> = ({ outdatedPassword, goBack }: Props) => {
  const { t } = useTranslation()

  const [sending, setSending] = useState(false)
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const [error, setError] = useState('')

  const sendPasswordReset = async (): Promise<void> => {
    setError('')

    if (!isValidEmail(email)) {
      setError(t('errors.invalidEmail'))
      return
    }

    setSending(true)

    const [resp, err] = await ClientService.resetPassword(email)
    if (resp) {
      setEmail('')
      setEmailSent(true)
    } else if (err?.length) {
      setError(t(`errors.${err[0].code}`))
    }

    setSending(false)
  }

  return (
    <div className="flex flex-col w-full">
      {/* Outdated Password */}
      {outdatedPassword && (
        <>
          <p className="mb-2">{t('content.passwordSecurity')}</p>
          <p className="mb-4">{t('content.passwordSecurityReset')}</p>
        </>
      )}

      <Input
        name="email"
        label={t('content.signup.email')}
        type="email"
        required
        autoFocus
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={error}
        solidBackground
      />
      <p className="text-center mb-4">
        {t(emailSent ? 'content.resetLinkSent' : 'content.solicitResetPassword')}
      </p>
      <div className="text-center">
        <Button type="button" onClick={sendPasswordReset} disabled={!email || sending}>
          {t('action.sendEmail')}
        </Button>
      </div>

      {!outdatedPassword && (
        <>
          {/* Or Separator */}
          <span className="text-sm my-6 opacity-75 w-full text-center">
            {t('content.orCapital')}
          </span>
          <button type="button" className="orange-link mb-6" onClick={goBack}>
            {t('action.signIn')}
          </button>
        </>
      )}
    </div>
  )
}

export default ForgotPassword
